// ReportsKpiCard — KPI card for reports dashboard
interface Props {
  label: string;
  value: string;
  icon: string;
  color: "primary" | "accent" | "secondary" | "warning" | "danger";
  subtitle: string;
}

const colorMap = {
  primary: { bg: "bg-primary-50", iconBg: "bg-primary-100", text: "text-primary-700", iconColor: "text-primary-500" },
  accent: { bg: "bg-accent-50", iconBg: "bg-accent-100", text: "text-accent-700", iconColor: "text-accent-500" },
  secondary: { bg: "bg-secondary-50", iconBg: "bg-secondary-100", text: "text-secondary-700", iconColor: "text-secondary-500" },
  warning: { bg: "bg-orange-50", iconBg: "bg-orange-100", text: "text-orange-700", iconColor: "text-orange-500" },
  danger: { bg: "bg-red-50", iconBg: "bg-red-100", text: "text-red-700", iconColor: "text-red-500" },
};

export default function ReportsKpiCard({ label, value, icon, color, subtitle }: Props) {
  const c = colorMap[color];
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4 hover:border-background-300/60 transition-colors cursor-default">
      <div className="flex items-start justify-between mb-3">
        <span className="text-xs font-medium text-foreground-500">{label}</span>
        <div className={`w-8 h-8 rounded-lg ${c.iconBg} flex items-center justify-center`}>
          <i className={`${icon} ${c.iconColor} w-full h-full flex items-center justify-center text-base`} />
        </div>
      </div>
      <div className={`text-2xl font-bold ${c.text} font-heading`}>{value}</div>
      <div className="text-xs text-foreground-400 mt-1">{subtitle}</div>
    </div>
  );
}